<section class="root tw-modal">
  <tw-icon class="modal-close-icon" icon="close" @click="close" />
  <slot></slot>
</section>
